import { LetterbookSettingType, LetterbooksPageProps } from "features/Letterbooks/types";
import Icon from "hardcover-ui/components/Icon";
import chevronRight from "icons/solid/chevron-right.svg";
import chevronLeft from "icons/solid/chevron-left.svg";
import TextLink from "hardcover-ui/components/TextLink";
import generateUrl from "features/Letterbooks/utils/generateUrl";
import { usePage } from "@inertiajs/react";

interface LetterbookOptions {
  settings: LetterbookSettingType;
}

export default function LetterbooksPagination({
  settings,
}: LetterbookOptions) {
  const { letterbooks } = usePage<LetterbooksPageProps>().props;
  const { limit, start } = settings;

  const { totalBooks } = letterbooks;
  if (letterbooks.letterbooks.length === limit && totalBooks > start + limit) {
    return (
      <div className="mt-8 flex flex-row justify-between px-2">
        {start - limit >= 0 ? (
          <TextLink
            href={generateUrl({
              settings,
              overrides: { start: String(start - limit) },
            })}
            className="flex row items-center space-x-1"
            size="md"
          >
            <Icon icon={chevronLeft} size="sm" />
            <span>Previous</span>
          </TextLink>
        ) : (
          <span />
        )}
        {start + limit < totalBooks ? (
          <TextLink
            href={generateUrl({
              settings,
              overrides: { start: String(start + limit) },
            })}
            className="flex row items-center space-x-1"
          >
            <span>Next</span>
            <Icon icon={chevronRight} />
          </TextLink>
        ) : (
          <span />
        )}
      </div>
    );
  }

  return false;
}
